import {
  ArrowLeftRight,
  BarChart3,
  Book,
  Building,
  Building2,
  Calendar,
  CheckSquare,
  UsersRound,
} from 'lucide-react';

import AdminCalendarTab from '@/components/v2/organisms/admin/tabs/AdminCalendarTab/AdminCalendarTab';
import AdminDashboardTab from '@/components/v2/organisms/admin/tabs/AdminDashboardTab/AdminDashboardTab';
import BusinessDashboardTab from '@/components/v2/organisms/admin/tabs/BusinessDashboardTab/BusinessDashboardTab';
import PropertiesTab from '@/components/v2/organisms/admin/tabs/PropertiesTab/PropertiesTab';
import BusinessTransactionsTab from '@/components/v2/organisms/admin/tabs/BusinessTransactionsTab/BusinessTransactionsTab';
import UserManagementTabs from '@/components/v2/organisms/admin/tabs/UserManagementTabs/UserManagementTabs';
import AdminTodosTab from '@/components/v2/organisms/admin/tabs/AdminTodosTab/AdminTodosTab';
import OrganizationsTab from '@/components/v2/organisms/admin/tabs/OrganizationsTab/OrganizationsTab';
import TransactionsTab from '@/components/v2/organisms/admin/tabs/TransactionsTab/TransactionsTab';
import ReservationsTab from '@/components/v2/organisms/admin/tabs/ReservationsTab/ReservationsTab';
import { Role } from './rolePermissions';

export interface AdminTab {
  key: string;
  label: string;
  description: string;
  component: React.ComponentType;
  icon: JSX.Element;
  group: 'property' | 'business';
}

export const adminTabs: AdminTab[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    description: 'Resumen general de tu operación',
    component: AdminDashboardTab,
    icon: <BarChart3 size={20} className="text-brand-primary" />,
    group: 'property',
  },
  {
    key: 'todos',
    label: 'Tareas',
    description: 'Lista de tareas pendientes y seguimiento de actividades',
    component: AdminTodosTab,
    icon: <CheckSquare size={20} className="text-brand-primary" />,
    group: 'property',
  },
  {
    key: 'calendar',
    label: 'Calendario',
    description: 'Disponibilidad y reservas',
    component: AdminCalendarTab,
    icon: <Calendar size={20} className="text-brand-primary" />,
    group: 'property',
  },
  {
    key: 'transactions',
    label: 'Transacciones',
    description: 'Ingresos y gastos de propiedades',
    component: TransactionsTab,
    icon: <ArrowLeftRight size={20} className="text-brand-primary" />,
    group: 'property',
  },
  {
    key: 'reservations',
    label: 'Reservaciones',
    description: 'Gestión de reservas y huéspedes',
    component: ReservationsTab,
    icon: <Book size={20} className="text-brand-primary" />,
    group: 'property',
  },
  {
    key: 'business-dashboard',
    label: 'Dashboard',
    description: 'Métricas e indicadores financieros del negocio',
    component: BusinessDashboardTab,
    icon: <BarChart3 size={20} className="text-brand-primary" />,
    group: 'business',
  },
  {
    key: 'business-transactions',
    label: 'Transacciones',
    description: 'Ingresos y egresos del negocio',
    component: BusinessTransactionsTab,
    icon: <ArrowLeftRight size={20} className="text-brand-primary" />,
    group: 'business',
  },
  {
    key: 'properties',
    label: 'Propiedades',
    description: 'Gestión de propiedades y contratos',
    component: PropertiesTab,
    icon: <Building2 size={20} className="text-brand-primary" />,
    group: 'business',
  },
  {
    key: 'users',
    label: 'Usuarios',
    description: 'Gestión de usuarios del sistema',
    component: UserManagementTabs,
    icon: <UsersRound size={20} className="text-brand-primary" />,
    group: 'business',
  },
  {
    key: 'organizations',
    label: 'Organizaciones',
    description: 'Gestionar organizaciones para clasificar propiedades',
    component: OrganizationsTab,
    icon: <Building size={20} className="text-brand-primary" />,
    group: 'business',
  },
];

export const propertyTabKeys = adminTabs
  .filter((tab) => tab.group === 'property')
  .map((tab) => tab.key);

export const businessTabKeys = adminTabs
  .filter((tab) => tab.group === 'business')
  .map((tab) => tab.key);

export const visibleTabsByRole: Record<Role, string[]> = {
  property_owner: ['dashboard', 'calendar', 'transactions'],
  property_manager: [
    'dashboard',
    'calendar',
    'reservations',
    'transactions',
    'properties',
    'organizations',
  ],
  cleaning: ['todos'],
  super_admin: adminTabs.map((tab) => tab.key),
};
